export const SESSION_COOKIE_NAME = 'lfvp_userSession';
export const SESSION_COOKIE_VALUE = '1800';
const session = window.sessionStorage.getItem(SESSION_COOKIE_NAME);

export const isNewSession = () => !session && session !== SESSION_COOKIE_VALUE;
